import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GetUnreadMessageCount } from "../BackendAccess/MessageHooks";

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(false);
  const location = useLocation();

  const refreshMessageCount = async () => {
    try {
      const [data, error] = await GetUnreadMessageCount();
      setUnreadCount(!error && data ? data : 0);
    } catch (err) {
      setUnreadCount(0);
    }
  };

  useEffect(() => {
    refreshMessageCount();
  }, [location.pathname]);

  return (
    <MessageContext.Provider
      value={{ unreadCount, setUnreadCount, refreshMessageCount }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageTracker = () => useContext(MessageContext);
